import { render } from "./SvgValve.vue?vue&type=template&id=f23ef1d8"
import script from "./SvgValve.vue?vue&type=script&lang=js"
export * from "./SvgValve.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__